import state from "./state";

/**
 * Mutación para cargar las asignaciones de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} asignaciones contiene la información de las asignaciones.
 */
export function cargarAsignaciones(state, asignaciones) {
    state.selectedBuscaEmpr.asignaciones = asignaciones
}

/**
 * Mutación para cargar la asignacion de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} asignaciones contiene la información de las asignaciones.
 */
export function cargarAsignacion(state, asignacion) {

    let index = state.selectedBuscaEmpr.asignaciones.findIndex(a => a.id === asignacion.id)

    if (index >= 0) {
        state.selectedBuscaEmpr.asignaciones.splice(index, 1, asignacion)
    }

}

/**
 * Mutación para cargar la información de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} infoProducto contiene la información del producto
 */
export function cargarInfoProducto(state, infoProducto) {
    state.infoProducto = infoProducto;
}

/**
 * Mutación para cargar las bases y áreas de una empresa.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} empresas contiene la información del proceso.
 */
export function cargarEmpresasBasesAreas(state, empresas) {
    state.empresas = empresas;
}

/**
 * Mutación para cargar las bases y áreas de una empresa.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} empresas contiene la información del proceso.
 */
export function cargarCamposPersonalizados(state, camposPersonalizados) {
    camposPersonalizados.map(cp => {
        state.empresas.map(e => {
            if (e.id === cp.id) {
                e.campos_personalizados = cp.campos_personalizados
            }
        })
    })
}


/**
 * Mutación para cargar las bases y áreas de un producto.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setUbicaciones(state, datos) {
    state.ubicaciones = datos
}

export function seleccionados(state, id) {
    state.seleccionado.push(id)
}

export function setSeleccionados(state, seleccionado = []) {
    state.seleccionado = seleccionado
}

/**
 * Mutación para cargar las bases y áreas de un producto.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function cargarBasesAreasProd(state, datos) {
    state.selectedBaseArea.bases_areas = [];
    state.selectedBaseArea.bases_areas_ori = [];
    state.selectedBaseArea.bases_areas_sinfil = [];

    state.selectedBaseArea.bases_areas = datos;
    state.selectedBaseArea.bases_areas_ori = datos;
    state.selectedBaseArea.bases_areas_sinfil = datos;
}

/**
 * Mutación para asignar la empresa y limpiar las ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setUbicacionEmpresa(state, datos) {
    state.selectedUbicacion.id_empresa = datos.id_empresa;
    state.selectedUbicacion.ubicaciones_id = [];
    if (datos.checked == true) {
        state.selectedUbicacion.accion = 2;
    } else {
        state.selectedUbicacion.accion = 1;
    }
}

/**
 * Mutación para ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setUbicacionProducto(state, datos) {
    state.selectedUbicacion.ubicaciones_id.push(datos.id);
    if (datos.children.length) {
        for (let i = 0; i < datos.children.length; i++) {
            setUbicacionProducto(state, datos.children[i]);
        }
    }
}

/* *
 * Mutación para ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setUbicacionMasivo(state, datos) {
    state.selectedUbicacion.id_empresa = datos.id_empresa;
    state.selectedUbicacion.ubicacion_id = datos.id;
}

/* *
 * Mutación para ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setMasivo(state, datos) {
    state.ubicSelecc = []
    state.ubicSelecc = datos;
}

/**
 * Mutación para ubicaciones.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} datos contiene la información del proceso.
 */
export function setInfo(state, datos) {
    state.info.empresa = datos.empresa;
    state.info.producto = datos.producto;
    state.info.esEmpresa = datos.asigEmpresa;
}

/**
 * Mutación para limpiar las bases y areas de un producto.
 *
 * @param {*} state contiene la información del proceso.
 */
export function limpiarBasesAreasProd(state) {
    state.selectedBaseArea.bases_areas = [];
    state.selectedBaseArea.bases_areas_ori = [];
    state.selectedBaseArea.bases_areas_sinfil = [];
    state.empresa = "";
}

/**
 * Mutación de prueba.
 *
 * @param {*} state contiene la información del proceso.
 * @param {*} empresas contiene la información del proceso.
 */
export function cargaCamposPersonalizados(state, empresas) {

    state.selectedCampos.id = empresas.id;
    state.selectedCampos.id_empresa = empresas.id_empresa;
    state.selectedCampos.campo = empresas.campo;
    state.selectedCampos.valor = empresas.valor;
}

export function asignado(state, asignacion) {
    state.asignado.id_empresa = asignacion.id
    state.asignado.nombre = asignacion.nombre
    state.asignado.activo = asignacion.activo
    state.asignado.asignado = asignacion.asignado
    state.asignado.activo_rpq = asignacion.activo_rpq
}

/**
 * Mutación para limpiar empresas de bases y areas.
 *
 * @param {*} state contiene la información del proceso.
 */
export function limpiarEmpresasBasesAreas(state) {

    state.empresas = [];
}

export function setModalAsignacionVer(state, value) {
    state.modalAsignacion.ver = value
    state.modalAsignacion.cargarUbicaciones = value
    state.modalAsignacion.cargarCamposPersonalizados = value
}

export function setModalAsignacionCargarUbicaciones(state, value) {
    state.modalAsignacion.cargarUbicaciones = value
}

export function setModalAsignacionCargarCamposPersonalizados(state, value) {
    state.modalAsignacion.cargarCamposPersonalizados = value
}

export function setCamposPersonalizados(state, camposPersonalizados){
  if (camposPersonalizados[0]){
    state.camposPersonalizados = camposPersonalizados[0].campos_personalizados
  }
}

export function resetSelectedEmpresa(state){
    state.selected_empresa = {}
}

/**
 * Agrega una empresa seleccionada al estado.
 *
 * @param {*} state
 * @param {*} company
 */
export function setSelectedEmpresa(state, company){
    state.selected_empresa = company
}

/**
 * Mutación que lista las ubicaciones con sus respectivas cantidad.
 *
 * @param {*} state contiene la información del proceso.
 */
export function setUbicacionesCantidad(state, data){
    state.ubicacionesCantidad = data
}

/**
 * Mutación para cambiar el estado de si se esta cancelando o no el proceso.
 *
 * @param {*} state.
 * @param {*} nextState.
 * @author Fernando Claros
 */
export function setLoadingCancelProcess(state, nextState){
    state.loadingCancelProcess = nextState
}

/**
 * Actualiza el estado para mostrar o oculatr el modal de asignacion productos pro empresas.
 *
 * @param {*} state
 * @param {*} value
 */
export function setModalSearchAndAssingProducts(state, value) {
    state.modalSearchAndAssingProducts.show = value
}


/**
 * Agregar el producto seleccionado al estado.
 *
 * @param {*} state
 * @param {*} product
 */
export function setSelectedProduct(state, product) {
    state.productSelectedToAssing = product
}
